export const PREFIX = "sticky-dip";
